import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=425c32ea&scoped=true&"
var script = {}
import style0 from "./Button.vue?vue&type=style&index=0&id=425c32ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c32ea",
  null
  
)

export default component.exports